var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "page-title" }, [
          _vm._v(" 准时签收率看板 | SLA | Delivery | Time Out "),
        ]),
        _c("div", { staticClass: "header-right" }, [
          _c(
            "span",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.queryList.mode === "SLA" ? "primary" : "",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleModeChange("SLA")
                    },
                  },
                },
                [_vm._v("SLA")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.queryList.mode === "DELIVERY" ? "primary" : "",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleModeChange("DELIVERY")
                    },
                  },
                },
                [_vm._v("Delivery")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.queryList.mode === "TIMEOUT" ? "primary" : "",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleModeChange("TIMEOUT")
                    },
                  },
                },
                [_vm._v("Time Out")]
              ),
            ],
            1
          ),
          _c("span", { staticClass: "update-time" }, [
            _vm._v("更新时间 Update time："),
            _c("span", { staticClass: "time-text" }, [
              _vm._v(_vm._s(_vm.updateTime || "- -")),
            ]),
            _vm._v("（há 3 dias）"),
          ]),
        ]),
      ]),
      _c("el-divider"),
      _c(
        "el-card",
        { staticClass: "search-card" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.queryList },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "flex-wrap": "wrap",
                    "align-items": "flex-end",
                  },
                  attrs: { gutter: 10, type: "flex", justify: "left" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 12, md: 12, sm: 12, lg: 3, xl: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "大区 Região" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                clearable: "",
                                filterable: "",
                                placeholder: _vm.$t("GlobalSetObj.all"),
                              },
                              on: { change: _vm.handleRegionChange },
                              model: {
                                value: _vm.queryList.regionId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryList, "regionId", $$v)
                                },
                                expression: "queryList.regionId",
                              },
                            },
                            _vm._l(_vm.regionList, function (item) {
                              return _c("el-option", {
                                key: item.regionId,
                                attrs: {
                                  label: item.regionName,
                                  value: item.regionId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, md: 12, sm: 12, lg: 3, xl: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "州 Estado/UF" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                placeholder: _vm.$t("GlobalSetObj.all"),
                              },
                              model: {
                                value: _vm.queryList.states,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryList, "states", $$v)
                                },
                                expression: "queryList.states",
                              },
                            },
                            _vm._l(_vm.stateList, function (item, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: item, value: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, md: 12, sm: 12, lg: 3, xl: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户名称 Nome do cliente" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                size: "small",
                                placeholder: _vm.$t(
                                  "spareNumberPoo.Only10AreDisplayed"
                                ),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getCustomerPage,
                              },
                              on: {
                                change: _vm.handleCustomerChange,
                                clear: function ($event) {
                                  return _vm.getCustomerPage("")
                                },
                                focus: function ($event) {
                                  return _vm.getCustomerPage("", true)
                                },
                              },
                              model: {
                                value: _vm.queryList.customerIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryList, "customerIds", $$v)
                                },
                                expression: "queryList.customerIds",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, md: 12, sm: 12, lg: 4, xl: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商户名称 Nome do comerciante" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                placeholder: _vm.$t("GlobalSetObj.all"),
                              },
                              model: {
                                value: _vm.queryList.merchantCodes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryList, "merchantCodes", $$v)
                                },
                                expression: "queryList.merchantCodes",
                              },
                            },
                            _vm._l(_vm.merchantList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    item.merchantName +
                                    "（" +
                                    item.merchantCode +
                                    "）",
                                  value: item.merchantCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, md: 12, sm: 12, lg: 3, xl: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "货物类型 Tipo de carga" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                clearable: "",
                                filterable: "",
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                              },
                              model: {
                                value: _vm.queryList.packageType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryList, "packageType", $$v)
                                },
                                expression: "queryList.packageType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.all"),
                                  value: "",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("placeOrder.Normal"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.big01"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, md: 12, sm: 12, lg: 4, xl: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "理应送达时间 Horário previsto" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              size: "small",
                              "range-separator": "~",
                              "start-placeholder": "开始日期 Data inicial",
                              "end-placeholder": "结束日期 Data final",
                              "value-format": "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions,
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "search-buttons" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "hover-move",
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索 Procurar")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "hover-move resetBtn",
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置 Resetar")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "qtd-toggle" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.showQtd
                              ? "显示 QTD 列 Mostrar colunas QTD"
                              : "隐藏 QTD 列 Ocultar colunas QTD",
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "hover-move qtd-toggle-btn",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.showQtd = !_vm.showQtd
                                },
                              },
                            },
                            [
                              _vm.showQtd
                                ? _c("i", {
                                    staticClass: "el-icon-view qtd-toggle-icon",
                                  })
                                : _c("img", {
                                    staticClass: "qtd-toggle-icon",
                                    attrs: {
                                      src: "/static/hide.png",
                                      alt: "qtd",
                                    },
                                  }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-divider"),
      _c("DailyAchievement", {
        attrs: { "res-data": _vm.dailyRes, "show-qtd": _vm.showQtd },
      }),
      _c(
        "el-row",
        {
          staticStyle: {
            "margin-left": "10px",
            "margin-right": "10px",
            "padding-bottom": "20px",
          },
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, lg: 12 } },
            [
              _c("WeeklyAchievement", {
                attrs: { "res-data": _vm.weeklyRes, "show-qtd": _vm.showQtd },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { xs: 24, lg: 12 } },
            [
              _c("MonthlyAchievement", {
                attrs: { "res-data": _vm.monthlyRes, "show-qtd": _vm.showQtd },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }